(function () {
  if (window.dolChristmasCountdownStarted) return;
  window.dolChristmasCountdownStarted = true;

  function updateCountdowns() {
    document.querySelectorAll('[data-db-campaign-countdown]').forEach(function (bar) {
      var end = Date.parse(bar.getAttribute('data-end'));
      var remaining = Math.max(0, Math.ceil((end - Date.now()) / 1000));
      var fallback = bar.parentElement.querySelector('[data-db-campaign-fallback]');

      if (!Number.isFinite(end) || remaining === 0) {
        bar.hidden = true;
        if (fallback) fallback.hidden = false;
        return;
      }

      bar.hidden = false;
      if (fallback) fallback.hidden = true;

      var values = {
        days: Math.floor(remaining / 86400),
        hours: Math.floor((remaining % 86400) / 3600),
        minutes: Math.floor((remaining % 3600) / 60),
        seconds: remaining % 60
      };

      Object.keys(values).forEach(function (unit) {
        var element = bar.querySelector('[data-' + unit + ']');
        if (element) element.textContent = String(values[unit]).padStart(2, '0');
      });
    });

  }

  updateCountdowns();
  window.setInterval(updateCountdowns, 1000);
  document.addEventListener('shopify:section:load', updateCountdowns);
})();
